import React, {PureComponent} from "react"

import {StatementItem} from "@irati/types"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"
import authentication from "@irati/auth"

import PrimaryDetails from "../../../PrimaryDetails"
import SecondaryDetails from "../../../SecondaryDetails/ViewMessage"
import ExpanderItem from "../../../ExpanderItem"
import {StyledCard} from "../../styled"
import buildMessageForStatementItem from "../../../../utils/buildMessageForStatementItem"

interface Props extends InjectIntl, WithBranding {
  statementItem: StatementItem,
  className?: string
}

class RewardPointsTransfer extends PureComponent<Props> {
  render() {
    const {statementItem, formatMessage, branding, className} = this.props
    const users = statementItem.transfer?.rewardedUsers
    const sender = statementItem.transfer?.sourceUser
    const messages = {
      messageOne: "wallet.statementItem.adminReward.transfer.received.primaryDetails.title.sender.one",
      messageTwo: "wallet.statementItem.adminReward.transfer.received.primaryDetails.title.sender.two",
      messageMany: "wallet.statementItem.adminReward.transfer.received.primaryDetails.title.sender.many",
      messageReceiver: "wallet.statementItem.adminReward.transfer.received.primaryDetails.title.received"
    }
    const title = buildMessageForStatementItem(
      users,
      formatMessage,
      messages,
      sender)

    const subTitle = statementItem.transfer?.message
      ? formatMessage({id: "wallet.statementItem.adminReward.transfer.subTitle"})
      : null

    const status = sender?.email === authentication.user().email
      ? StatusType.REWARD_WALLET_SPENT
      : StatusType.REWARD_WALLET_CLEARED
    const primaryDetails = {
      image: branding.businessLogoUrl || perkboxLogo,
      title,
      subTitle,
      amount: getNormalisedValue(true, statementItem.transfer?.currency, Math.abs(statementItem.transfer?.amount)),
      currency: statementItem.transfer?.currency,
      status
    }

    if (!statementItem.transfer?.message && users?.length <= 2) {
      return (
        <StyledCard medium noBorder>
          <PrimaryDetails imgHeightAuto data={primaryDetails} />
        </StyledCard>
      )
    }

    const secondaryDetails = {
      message: statementItem.transfer?.message,
      userMessage: buildMessageForStatementItem(
        users,
        formatMessage,
        {...messages, messageManyFull: "wallet.statementItem.adminReward.transfer.received.primaryDetails.title.sender.manyFull"},
        sender)
    }
    return (
      <ExpanderItem
        className={className}
        PrimaryElement={() => <PrimaryDetails imgHeightAuto data={primaryDetails} />}
        SecondaryElement={<SecondaryDetails data={secondaryDetails} />} />
    )
  }
}

export default injectIntl(withBranding(RewardPointsTransfer))
